import React, { FC } from 'react';
// import ProductCard from "../../../../../commons/components/cards/ProductCard";
import {
  Grid,
  makeStyles,
  createStyles,
} from '@material-ui/core';
import PrintedPage from '../components/PrintedPage';

interface FeaturedProductsProps {
  pageNumber: number;
  products: any[];
}

const useStyles = makeStyles(() => createStyles({
  gridroot: {
    margin: '0px',
    width: '793px',
  },
}));

const FeaturedProducts: FC<FeaturedProductsProps> = (props) => {
  const classes = useStyles();
  return (
    <PrintedPage
      pageTitle="Productos de la Temporada"
      pageNumber={props?.pageNumber}
    >
      <Grid className={classes.gridroot} container spacing={3}>
        {/* {props.products.map((product: any, index: number) => (
          <ProductCard key={index} product={product} />
        ))} */}
      </Grid>
    </PrintedPage>
  );
};

export default FeaturedProducts;
